<template>
  <router-view></router-view>
</template>

<style lang="scss">
// 3rd party plugins css
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~animate.css';
@import 'assets/plugins/flaticon/flaticon.css';
@import 'assets/plugins/flaticon2/flaticon.css';
@import 'assets/plugins/keenthemes-icons/font/ki.css';
@import 'assets/sass/style.vue';
@import '~line-awesome/dist/line-awesome/css/line-awesome.css';
</style>

<script>
import {OVERRIDE_LAYOUT_CONFIG} from '@/core/services/store/config.module'

export default {
  name: 'VendingTycoonClient',
  mounted() {
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG)
  },
}
</script>
